<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="609" @click:outside="closeModal">
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">{{
                $t("Upload XLS File")
              }}</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <form autocomplete="off">
              <v-card-text class="black--text">
                <v-btn color="primary" class="my-3" @click="downloadTemplate">
                  {{ $t("Export XLS Format") }}
                  <v-icon small class="ml-2">mdi-tray-arrow-down</v-icon>
                </v-btn>
                <div class="form">
                  <div v-if="!file">
                    <div
                      :class="['dropZone', dragging ? 'dropZone-over' : '']"
                      @dragenter="dragging = true"
                      @dragleave="dragging = false"
                    >
                      <div class="dropZone-info" @drag="onChange">
                        <img width="50" src="/img/xlsx-upload.svg">
                        <span class="fa fa-cloud-upload dropZone-title"></span>
                        <!-- <span class="dropZone-title">
                          <v-icon x-large color="primary"
                            >mdi-tray-arrow-up</v-icon
                          >
                        </span> -->
                        <div class="d-flex-start">
                          <div class="info--text">Select a XLS file to upload</div>
                        </div>
                        <div class="dropZone-upload-limit-info">
                          <div>or drag and drop here</div>
                        </div>
                      </div>
                      <input type="file" accept=".xls, .xlsx, .csv" @change="onChange" />
                    </div>
                    <span class="red--text">{{ fileError }}</span>
                  </div>
                  <div v-else class="dropZone-uploaded">
                    <div class="dropZone-uploaded-info">
                      <v-btn
                        class="ma-2 white--text"
                        @click="removeFile"
                        color="info"
                        outlined
                      >
                        {{ $t("removeFile") }}
                        <v-icon right dark> mdi-trash-can </v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <!-- <div class="link-upload">
                    <div class="link-label my-2">
                      <span>{{ $t("Or upload from a URL") }}</span>
                    </div>
                    <v-row no-gutters class="link-input">
                      <input 
                        id="uploadUrl" 
                        class="link-text" 
                        type="url"
                        v-model="link"
                        :placeholder="$t('Add the file URL')">
                      <v-btn
                        class="link-btn"
                        :disabled="link === '' || linkError" 
                        outlined
                        background-color="white"
                        @click="loadFileFromUrl">
                        {{ $t("Upload") }}
                      </v-btn>
                    </v-row>
                  </div> -->
                  <v-chip 
                    v-if="file" 
                    label 
                    color="grey lighten-4" 
                    class=" mt-4 uploadedFile-info">
                    <v-icon left small>
                      mdi-file-check
                    </v-icon>
                    {{ file.name }}
                  </v-chip>
                  <div v-if="progress > 0" class="row mt-2">
                    <div class="col-11">
                      {{ progressText }}
                    </div>
                    <div class="col-1">
                      <v-icon
                        :color="progressColor"
                        dense>
                        {{ progressIcon }}
                      </v-icon>
                    </div>
                  </div>
                  <div class="row mt-0" v-if="progress > 0">
                    <div class="col-11 progress-bar">
                      <v-progress-linear :value="progress" :color="progressColor" rounded></v-progress-linear>
                    </div>
                    <div class="col-1 pl-0">
                      <small :class="'progress-num ' + progressColor + '--text'">{{ progress }} %</small>
                    </div>
                  </div>
                  <div class="row mt-0" v-if="responseMessage !== ''">
                    <small :class="progressColor + '--text'">{{ responseMessage }}</small>
                  </div>
                </div>
                <v-divider class="my-5 px-0"></v-divider>
                <v-card-actions class="px-0">
                  <v-spacer></v-spacer>
                  <v-btn
                    class="mr-2"
                    outlined
                    color="primary"
                    @click="closeModal"
                    width="112"
                  >
                    {{ $t("cancel") }}
                  </v-btn>
                  <v-btn
                    v-if="progress < 100"
                    :disabled="!file"
                    width="112"
                    color="primary"
                    class="btn-11 btn-22"
                    @click="uploadFile"
                  >
                    {{ $t("Proceed") }}
                  </v-btn>
                  <v-btn
                    v-else
                    width="112"
                    color="primary"
                    class="btn-11 btn-22"
                    @click="resetAndCloseDialog"
                  >
                    {{ $t("close") }}
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </form>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import FileService from "@/_services/FileService";

export default {
  computed: {
    dialog: {
      get() {
        return this.dialogI;
      },
      set() {
        return this.dialogI;
      },
    },
  },
  data() {
    return {
      file: "",
      fileError: "",
      progressText: 'Uploading...',
      progressColor: 'success',
      progressIcon: 'mdi-progress-upload',
      responseMessage: '',
      uploadError: false,
      progress: 0,
      link: "",
      linkError: false,
      dragging: false,
    };
  },
  methods: {
    closeModal(success = false) {
      this.$emit("closeUploadGenetics", success);
    },
    onChange(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        this.dragging = false;
        return;
      }

      this.createFile(files[0]);
    },
    createFile(file) {
      // if (!['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'].includes(file.type)) {
      //   this.fileError = this.$t("Only XLSX files are allowed");
      //   this.dragging = false;
      //   return;
      // }

      // if (file.size > 5000000) {
      //     alert('please check file size no over 5 MB.')
      //     this.dragging = false;
      //     return;
      // }

      this.file = file;
      this.dragging = false;
    },
    removeFile() {
      this.file = "";
    },
    uploadFile() {
      let formData = new FormData();
      formData.append("csvFile", this.file);
      //formData.append("userId",  parseInt(this.$store.getters.getUser.id));
      FileService.sendFile(
        'bulkUpload',
        formData,
        (progressEvent) => {
          this.progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
        },
        this.$store.getters.getUser.token
      ).then((resp) => {
        this.responseMessage = resp.message;
        if (resp.success) {
          this.progressText = "Completed Successfully!";
          this.progressIcon = "mdi-check-circle";
        } else {
          this.progressText = "Upload Failed!";
          this.progressColor = "red";
          this.uploadError = true;
          this.progressIcon = "mdi-close-circle";
        }
      })
      .catch((err) => {
        console.log(err);
        this.progressText = "Upload Error!";
        this.progressColor = "red";
        this.uploadError = true;
        this.progressIcon = "mdi-close-circle";
      });
    },
    resetAndCloseDialog() {
      this.closeModal(!this.uploadError);
      this.file = "";
      this.progress = 0;
      this.progressColor = "success";
      this.progressIcon = "mdi-progress-upload";
      this.progressText = "Uploading...";
      this.responseMessage = "";
      this.uploadError = false;
    },
    checkLink() {},
    loadFileFromUrl() {
      this.startLoading();
      FileService.getFile(this.link)
        .then((resp) => {
          this.stopLoading();
          if (resp.success) {
            const blob = resp.blob;
            const fileName = this.link.slice(this.link.lastIndexOf("/") + 1);
            const file = new File(
              [blob], 
              fileName,
              {
                lastModified: new Date().getTime(),
                type: blob.type,
                size: blob.size
              });
            this.file = file;
          }
        })
        .catch((err) => {
          this.stopLoading();
          console.log(err)
        })
    },
    downloadTemplate() {
      this.startLoading();
      const templateFile = 'template.xlsx';
      const url = process.env.PYTHON_BACKEND || 'https://lgcloud.dimitra.dev';
      FileService.getFile(`${url}/files/${templateFile}`)
        .then((resp) => {
          this.stopLoading();
          if (resp.success) {
            const resourceElement = document.createElement("a");
            resourceElement.download = templateFile;
            resourceElement.href = URL.createObjectURL(resp.blob);
            resourceElement.click();
          }
        })
        .catch((err) => {
          this.stopLoading();
          console.log(err)
        })
    }
  },

  props: ["dialogI"],
  mixins: [loadingMixin],
};
</script>
<style lang="scss" scoped>
.progress-bar {
  display: flex;
  justify-content: center;
  align-items: center;
}

.progress-num {
  display: flex;
  justify-content: flex-end;
  font-weight: bold;
}

.uploadedFile-info {
  width: 100%;
  padding: 18px;
}

.dropZone {
  width: 100%;
  height: 150px;
  position: relative;
  border: 2px dashed #97a8b8;
  padding: 100px 0;
}

.dropZone:hover {
  border: 2px solid $primary-color;
}

.dropZone:hover .dropZone-title {
  color: $primary-color;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5c5c5c;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 100%;
  height: 150px;
  position: relative;
  border: 2px solid $primary-color;
  // border-radius: 10px;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}

.link-input {
  border-radius: 8px;
  background-color: rgba(209, 209, 209, 0.15);
  padding: 8px;

  .link-text {
    background: none;
    border: none;
    padding: 8px;
    width: 80%;

    &:focus {
      outline: none;
    }
  }

  .link-btn {
    width: 20%;
    background-color: white;
  }
}
</style>
